<template>


  <div class="grid-main bg-purple " >
    <h2 style="float: left">运营商列表</h2>
    <el-button type="primary" @click="dialogoperatorAdd=true">添加运营商</el-button>
    <div class="table-box" >

      <el-table
        :data="operatorList.list"
        height="550"
        border
        style="width: 100%;">
        <el-table-column
          prop="operatorNum"
          label="序号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="operatorName"
          label="企业名称"
          width="180">
        </el-table-column>
        <el-table-column

          label="logo">
          <template slot-scope="scope">
            <img :src="scope.row.logo" alt="" style="width: 64px;
                                       height: 64px;
                                       border: 2px solid #FFFFFF;
                                       border-radius: 50%;"/>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作">
          <template slot-scope="scope">
            <el-button
            	type="success"
              size="mini"
              @click="openoperator(scope.row.id)">编辑</el-button>
            <el-button

              size="mini"
              type="danger"
              @click="openDelete(scope.row.id)">删除</el-button>

          </template>
        </el-table-column>

      </el-table>
      <el-pagination
      	v-if="operatorList.operatorListtotal>10"
        background
        layout="prev, pager, next"
        :page-size="operatorList.operatorListpageSize"
        @current-change="setselectOperatorlist"
        :total="operatorList.operatorListtotal">

      </el-pagination>
    </div>



  <!--企业修改-->

  <el-dialog  :visible.sync="dialogoperatorAdd" :before-close="dialogoperatorclose">
    <el-form ref="form"  label-width="150px">
      <el-form-item label="logo：">
        <el-upload
          class="avatar-uploader"
          :action="afileUrl"
          name="files"
          :show-file-list="false"
          :on-success="handleimgSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="fileimg" :src="fileimg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="企业编码：">
        <el-input v-model="operatorAdds.operatorNum" type="number" min="0" placeholder="请输入企业编码："></el-input>
      </el-form-item>


      <el-form-item label="企业名称：">
        <el-input v-model="operatorAdds.operatorName" type="text" placeholder="请输入企业名称："></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="operatorAdd()">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>



  <el-dialog :visible.sync="dialogupdataoperator" :before-close="dialogoperatorclose">
    <el-form ref="form"  label-width="150px">
      <el-form-item label="logo：">
        <el-upload
          class="avatar-uploader"
          :action="afileUrl"
          name="files"
          :show-file-list="false"
          :on-success="handleimgSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="fileimg" :src="fileimg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>


      <el-form-item label="企业名称：">
        <el-input v-model="updateOperators.operatorName" type="text"  placeholder="请输入企业名称："></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="updateOperator">确认提交</el-button>

      </el-form-item>
    </el-form>
  </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Operator",
  data(){
    return {
      operatorList:{
        list:[],
        operatorListpage:1,
        operatorListtotal:0,
        operatorListpageSize:10
      },
      //新增企业
      operatorAdds:{
        logo:'',
        operatorName:'',
        operatorNum:'',
      },
      dialogoperatorAdd:false,
      fileimg:'',

      afileUrl:'/api/upload/imgs',
      operatorId:'',
      dialogupdataoperator:false,
      updateOperators:{
        logo:'',
        operatorName:'',
      },

    }
  },
  beforeRouteEnter(to,from,next){

    next((vm)=>{

    });
  },
  created(){

  },
  mounted () {
     this.selectOperatorlist();
  },
  methods: {
    dialogoperatorclose(){
      this.dialogupdataoperator = false;
      this.fileimg = '';
      this.updateOperators = {
        logo:'',
        operatorName:'',
      };
      this.dialogoperatorAdd=false;
      this.operatorAdds={
        logo:'',
        operatorName:'',
        operatorNum:'',
      };
    },
    //通用上传
    handleimgSuccess(res, file) {
      let that = this;

      if(res.data.errno==0){
        that.fileimg = res.data.data[0];
      }else{
        that.$message.error('上传失败');
      }
    },

    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG、JPEG、PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    //企业列表
    selectOperatorlist(){
      let that = this;
      let operatordata = {
        page:this.operatorList.operatorListpage,
        pageSize:this.operatorList.operatorListpageSize,
      }
      this.$axios.defaults.withCredentials=true;
      this.$axios
        .post('/api/operator/selectOperator',operatordata)
        .then(function (res) {

          if(res.data.code==200){
            that.operatorList.list = res.data.data.list;
            that.operatorList.operatorListtotal = res.data.data.total;
          }
          else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    setselectOperatorlist(operatorListpage){
      this.operatorList.operatorListpage = operatorListpage;
      this.selectOperatorlist();
    },

    operatorAdd(){
      let that = this;
      that.operatorAdds.logo = that.fileimg
      if (that.operatorAdds.logo == '') {
        that.$message.error('请上传头像');
        return false;
      }

      if (that.operatorAdds.operatorNum == '') {
        that.$message.error('请输入企业编码');
        return false;
      }
      if (that.operatorAdds.operatorName == '') {
        that.$message.error('请输入企业名称');
        return false;
      }

      let operatorAdddata = {
        operatorNum:that.operatorAdds.operatorNum,
        operatorName:that.operatorAdds.operatorName,
        logo:that.operatorAdds.logo
      }
      this.$axios
        .post('/api/operator/operatorAdd', operatorAdddata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("新增企业失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '新增企业成功',
              type: 'success'
            });

            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);

          }


        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });


    },


    selectOperatorById(){
      let that = this;
      let updateOperatoriddata = {
        id:that.operatorId,
      }
      this.$axios
        .post('/api/operator/selectOperatorById', updateOperatoriddata)
        .then(function (res) {

          that.fileimg=res.data.data.logo;
          that.updateOperators.operatorName=res.data.data.operatorName;
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    openoperator(operatorId){
      this.operatorId = operatorId;

      this.selectOperatorById();
      window.setTimeout(() => {
        this.dialogupdataoperator = true;
      },100);


    },

    //修改企业信息
    updateOperator(operatorId){
      let that = this;
      that.updateOperators.logo =that.fileimg;

      if (that.updateOperators.logo == '') {
        that.$message.error('请上传头像');
        return false;
      }

      if (that.updateOperators.operatorNum == '') {
        that.$message.error('请输入企业编码');
        return false;
      }
      if (that.updateOperators.operatorName == '') {
        that.$message.error('请输入企业名称');
        return false;
      }
      let updateOperatordata = {
        id:this.operatorId,
        logo:that.updateOperators.logo,
        operatorName:that.updateOperators.operatorName
      }
      this.$axios
        .post('/api/operator/updateOperator', updateOperatordata)
        .then(function (res) {
          if (res.data.code == 500) {
            that.$message.error("修改企业失败:"+res.data.msg);
            return false;
          } else if (res.data.code == 200) {
            that.$message({
              message: '修改企业成功',
              type: 'success'
            });

            //  this.show == true;
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },

    openDelete(operatorId) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this. deleteOperator(operatorId);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //删除企业信息
    deleteOperator(operatorId){
      let that = this;
      let operatorIds = {
        operatorId:operatorId
      }
      this.$axios
        .post('/api/operator/deleteOperator',operatorIds)
        .then(function (res) {

          if(res.data.code==200){
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            window.setTimeout(() => {
              location.reload();
            }, 1000);
          }
          else{
            that.$message.error(res.data.msg);
          }
        }).catch(function (error) { // 请求失败处理
        console.log("服务器错误"+error);
      });
    },


  },
  watch: {

  },

}
</script>

<style scoped>
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  float: left;
}
/deep/ .el-upload:hover {
  border-color: #409EFF;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

/deep/ .avatar {
  width: 60px;
  height: 60px;
  display: block;
}</style>



// WEBPACK FOOTER //
// src/view/admin/Operator.vue